"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestFuturesAccount = exports.receiveSystemFuturesEnabled = exports.receiveFuturesOrderTotal = exports.receiveFuturesMaxQuantity = exports.receiveFuturesKVPInfo = exports.receiveFuturesEstimatedMaxAmount = exports.receiveFuturesAccountInfo = exports.preloadFuturesData = exports.initFuturesTrading = exports.getFuturesProducts = exports.getFuturesMaxQuanity = exports.getFuturesMaxPosition = exports.getFuturesKVP = exports.getFuturesEstimatedMaxAmount = exports.getFuturesAccountInfo = exports.getContractDetails = exports.getAccountFuturesBalances = exports.UPDATE_FUTURES_BALANCES = exports.UPDATE_FUTURES_ACCOUNT_INFO = exports.REQUEST_FUTURES_MAX_QUANTITY = exports.REQUEST_FUTURES_CONTRACT_DETAILS = exports.REQUEST_FUTURES_BALANCES = exports.REQUEST_FUTURES_ACCOUNT_INFO = exports.RECEIVE_SYSTEM_FUTURES_ENABLED = exports.RECEIVE_FUTURES_PRODUCTS = exports.RECEIVE_FUTURES_ORDER_TOTAL = exports.RECEIVE_FUTURES_MAX_QUANTITY = exports.RECEIVE_FUTURES_KVP_INFO = exports.RECEIVE_FUTURES_ESTIMATED_MAX_AMOUNT = exports.RECEIVE_FUTURES_CONTRACT_DETAILS = exports.RECEIVE_FUTURES_BALANCES = exports.RECEIVE_FUTURES_ACCOUNT_INFO = exports.GetFuturesOrderCost = exports.FUTURES_MAX_POSITION = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _userActions = require("../../actions/userActions");
var _futuresPositionsActions = require("./futuresPositionsActions");
var _futuresSelectors = require("../../../redux/futures/selectors/futuresSelectors");
var _futuresInstrumentsSelector = require("../selectors/futuresInstrumentsSelector");
var _futuresOrdersActions = require("./futuresOrdersActions");
var _FuturesBalancesSubsciptionService = _interopRequireDefault(require("../services/FuturesBalancesSubsciptionService"));
var _FuturesAccountSummarySubscriptionService = _interopRequireDefault(require("../services/FuturesAccountSummarySubscriptionService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var preloadFuturesData = exports.preloadFuturesData = function preloadFuturesData(AccountId) {
  return function (dispatch) {
    // Get account info, open orders, etc.
    // Still more to add below of course
    dispatch(getFuturesAccountInfo(AccountId));
    dispatch((0, _futuresOrdersActions.getFuturesOpenOrders)(AccountId));
    dispatch((0, _futuresPositionsActions.getFuturesOpenPositions)(AccountId));
    dispatch((0, _futuresPositionsActions.getFuturesPositionHistory)(AccountId));
    dispatch(getFuturesAccountInfo(AccountId));
    dispatch((0, _futuresPositionsActions.subscribeToFuturesPositionEvents)(AccountId));
    dispatch(subscribeFuturesBalanceEvents(AccountId));
    dispatch(subscribeFuturesAccountSummaryEvents(AccountId));
  };
};
var REQUEST_FUTURES_CONTRACT_DETAILS = exports.REQUEST_FUTURES_CONTRACT_DETAILS = 'REQUEST_FUTURES_CONTRACT_DETAILS';
var RECEIVE_FUTURES_CONTRACT_DETAILS = exports.RECEIVE_FUTURES_CONTRACT_DETAILS = 'RECEIVE_FUTURES_CONTRACT_DETAILS';
var getContractDetails = exports.getContractDetails = function getContractDetails(_ref) {
  var OMSID = _ref.OMSID,
    InstrumentId = _ref.InstrumentId,
    AccountId = _ref.AccountId;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var responseObj, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            dispatch({
              type: REQUEST_FUTURES_CONTRACT_DETAILS
            });
            _context.p = 1;
            _context.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetFuturesInstrumentContractDetails', {
              OMSID: OMSID,
              InstrumentId: InstrumentId,
              AccountId: AccountId
            }));
          case 2:
            responseObj = _context.v;
            if ((responseObj === null || responseObj === void 0 ? void 0 : responseObj.IsSuccess) === false) {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getContractDetailsError',
                text: responseObj.errormsg,
                type: 'warning'
              }));
            } else {
              dispatch({
                type: RECEIVE_FUTURES_CONTRACT_DETAILS,
                payload: responseObj
              });
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('getContractDetails error: ', _t);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'getContractDetailsError',
              text: _t.o,
              type: 'warning'
            }));
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var requestFuturesAccount = exports.requestFuturesAccount = function requestFuturesAccount() {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var UserId, responseObj, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context2.p = 1;
            _context2.n = 2;
            return dispatch((0, _apiActions.callAPI)('RequestFuturesAccount', {}));
          case 2:
            responseObj = _context2.v;
            if (!(responseObj && responseObj.result == false)) {
              _context2.n = 3;
              break;
            }
            dispatch((0, _snackbarActions.showSnack)({
              id: 'requestFuturesAccountError',
              text: responseObj.errormsg,
              type: 'warning'
            }));
            return _context2.a(2, false);
          case 3:
            dispatch((0, _userActions.getUserInfo)(UserId));
            return _context2.a(2, true);
          case 4:
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            console.error('requestFuturesAccountError error: ', _t2);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'requestFuturesAccountError',
              text: _t2.o,
              type: 'warning'
            }));
            return _context2.a(2, false);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5]]);
    }));
    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var RECEIVE_FUTURES_KVP_INFO = exports.RECEIVE_FUTURES_KVP_INFO = 'RECEIVE_FUTURES_KVP_INFO';
var receiveFuturesKVPInfo = exports.receiveFuturesKVPInfo = function receiveFuturesKVPInfo(futuresKVPInfo) {
  return {
    type: RECEIVE_FUTURES_KVP_INFO,
    payload: futuresKVPInfo
  };
};
var getFuturesKVP = exports.getFuturesKVP = function getFuturesKVP() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var res, _ref5, _ref5$FuturesVerifica, FuturesVerificationLevels, _ref5$MinimumDeposit, MinimumDeposit, payload, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetGeneralFuturesParameters'));
          case 1:
            res = _context3.v;
            _ref5 = res !== null && res !== void 0 ? res : {}, _ref5$FuturesVerifica = _ref5.FuturesVerificationLevels, FuturesVerificationLevels = _ref5$FuturesVerifica === void 0 ? '' : _ref5$FuturesVerifica, _ref5$MinimumDeposit = _ref5.MinimumDeposit, MinimumDeposit = _ref5$MinimumDeposit === void 0 ? 0 : _ref5$MinimumDeposit;
            payload = {
              futuresVerificationLevels: FuturesVerificationLevels,
              minDepositValue: MinimumDeposit
            };
            dispatch(receiveFuturesKVPInfo(payload));
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t3 = _context3.v;
            console.error('getFuturesKVP error: ', _t3);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'getFuturesKVPError',
              text: _t3.o,
              type: 'warning'
            }));
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var REQUEST_FUTURES_BALANCES = exports.REQUEST_FUTURES_BALANCES = 'REQUEST_FUTURES_BALANCES';
var RECEIVE_FUTURES_BALANCES = exports.RECEIVE_FUTURES_BALANCES = 'RECEIVE_FUTURES_BALANCES';
var UPDATE_FUTURES_BALANCES = exports.UPDATE_FUTURES_BALANCES = 'UPDATE_FUTURES_BALANCES';
var getAccountFuturesBalances = exports.getAccountFuturesBalances = function getAccountFuturesBalances(AccountId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var OMSId, HideSmallAmounts, responseObj, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            HideSmallAmounts = localStorage.getItem('hideMarginSmallAmounts') !== 'false';
            _context4.p = 1;
            dispatch({
              type: REQUEST_FUTURES_BALANCES
            });
            _context4.n = 2;
            return dispatch((0, _apiActions.callAPI)("GetFuturesAccountBalances", {
              OMSId: OMSId,
              AccountId: AccountId,
              HideSmallAmounts: HideSmallAmounts
            }));
          case 2:
            responseObj = _context4.v;
            if (!responseObj) {
              _context4.n = 3;
              break;
            }
            dispatch({
              type: RECEIVE_FUTURES_BALANCES,
              payload: responseObj
            });
            return _context4.a(2, true);
          case 3:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetAccountFuturesBalancesError',
              text: 'Get Account Futures Balances Error.',
              type: 'warning'
            }));
            return _context4.a(2, false);
          case 4:
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t4 = _context4.v;
            console.error('GetAccountFuturesBalancesError error: ', _t4);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetAccountFuturesBalancesError',
              text: _t4.o,
              type: 'warning'
            }));
            return _context4.a(2, false);
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 5]]);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var subscribeFuturesBalanceEvents = function subscribeFuturesBalanceEvents(AccountId) {
  return function (dispatch) {
    _FuturesBalancesSubsciptionService["default"].subscribe(function (payload) {
      dispatch({
        type: UPDATE_FUTURES_BALANCES,
        payload: payload.filter(function (item) {
          return item.AccountId === AccountId;
        })
      });
    });
  };
};
var RECEIVE_SYSTEM_FUTURES_ENABLED = exports.RECEIVE_SYSTEM_FUTURES_ENABLED = 'RECEIVE_SYSTEM_FUTURES_ENABLED';
var receiveSystemFuturesEnabled = exports.receiveSystemFuturesEnabled = function receiveSystemFuturesEnabled(systemFuturesEnabled) {
  return {
    type: RECEIVE_SYSTEM_FUTURES_ENABLED,
    payload: {
      systemFuturesEnabled: systemFuturesEnabled
    }
  };
};
var initFuturesTrading = exports.initFuturesTrading = function initFuturesTrading(systemFuturesEnabled) {
  return function (dispatch) {
    dispatch(receiveSystemFuturesEnabled(systemFuturesEnabled));
    dispatch(getFuturesKVP());
  };
};
var RECEIVE_FUTURES_PRODUCTS = exports.RECEIVE_FUTURES_PRODUCTS = 'RECEIVE_FUTURES_PRODUCTS';
var getFuturesProducts = exports.getFuturesProducts = function getFuturesProducts() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var OMSId, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            _context5.p = 1;
            _context5.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetFuturesProducts', {
              OMSId: OMSId
            }));
          case 2:
            data = _context5.v;
            dispatch({
              type: RECEIVE_FUTURES_PRODUCTS,
              payload: (data === null || data === void 0 ? void 0 : data.Result) || []
            });
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            console.error('GetFuturesProducts error: ', _t5);
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var REQUEST_FUTURES_ACCOUNT_INFO = exports.REQUEST_FUTURES_ACCOUNT_INFO = 'REQUEST_FUTURES_ACCOUNT_INFO';
var RECEIVE_FUTURES_ACCOUNT_INFO = exports.RECEIVE_FUTURES_ACCOUNT_INFO = 'RECEIVE_FUTURES_ACCOUNT_INFO';
var UPDATE_FUTURES_ACCOUNT_INFO = exports.UPDATE_FUTURES_ACCOUNT_INFO = 'UPDATE_FUTURES_ACCOUNT_INFO';
var receiveFuturesAccountInfo = exports.receiveFuturesAccountInfo = function receiveFuturesAccountInfo(accountInfo) {
  return {
    type: RECEIVE_FUTURES_ACCOUNT_INFO,
    payload: accountInfo
  };
};
var getFuturesAccountInfo = exports.getFuturesAccountInfo = function getFuturesAccountInfo(AccountId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch, getState) {
      var OMSId, responseObj, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            if (OMSId) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            dispatch({
              type: REQUEST_FUTURES_ACCOUNT_INFO
            });
            _context6.p = 2;
            _context6.n = 3;
            return dispatch((0, _apiActions.callAPI)('GetFuturesAccountSummary', {
              OMSId: OMSId,
              AccountId: AccountId
            }));
          case 3:
            responseObj = _context6.v;
            if (!(responseObj && responseObj.result !== false)) {
              _context6.n = 4;
              break;
            }
            dispatch(receiveFuturesAccountInfo(responseObj));
            return _context6.a(2, true);
          case 4:
            console.error('GetFuturesAccountSummary error: ', responseObj);
            return _context6.a(2, false);
          case 5:
            _context6.n = 7;
            break;
          case 6:
            _context6.p = 6;
            _t6 = _context6.v;
            console.error('GetFuturesAccountSummary error: ', _t6);
            return _context6.a(2, false);
          case 7:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 6]]);
    }));
    return function (_x9, _x0) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var subscribeFuturesAccountSummaryEvents = function subscribeFuturesAccountSummaryEvents(AccountId) {
  return function (dispatch) {
    _FuturesAccountSummarySubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        dispatch({
          type: UPDATE_FUTURES_ACCOUNT_INFO,
          payload: payload
        });
      }
    });
  };
};
var REQUEST_FUTURES_MAX_QUANTITY = exports.REQUEST_FUTURES_MAX_QUANTITY = 'REQUEST_FUTURES_MAX_QUANTITY';
var RECEIVE_FUTURES_MAX_QUANTITY = exports.RECEIVE_FUTURES_MAX_QUANTITY = 'RECEIVE_FUTURES_MAX_QUANTITY';
var receiveFuturesMaxQuantity = exports.receiveFuturesMaxQuantity = function receiveFuturesMaxQuantity(maxQuantity) {
  return {
    type: RECEIVE_FUTURES_MAX_QUANTITY,
    payload: maxQuantity
  };
};
var getFuturesMaxQuanity = exports.getFuturesMaxQuanity = function getFuturesMaxQuanity(InstrumentId, LeverageMultiplier) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
      var state, AccountId, responseObj, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            dispatch({
              type: REQUEST_FUTURES_MAX_QUANTITY
            });
            _context7.p = 1;
            state = getState();
            AccountId = (0, _futuresSelectors.futuresAccountIdSelector)(state);
            _context7.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetFuturesOrderMaxAmount', {
              AccountId: AccountId,
              InstrumentId: InstrumentId,
              LeverageMultiplier: LeverageMultiplier
            }));
          case 2:
            responseObj = _context7.v;
            if (!(responseObj && responseObj.result !== false)) {
              _context7.n = 3;
              break;
            }
            dispatch(receiveFuturesMaxQuantity(responseObj));
            return _context7.a(2, true);
          case 3:
            console.error('GetFuturesMaxQuantity error: ', responseObj);
            return _context7.a(2, false);
          case 4:
            _context7.n = 6;
            break;
          case 5:
            _context7.p = 5;
            _t7 = _context7.v;
            console.error('GetFuturesMaxQuantity error: ', _t7);
            return _context7.a(2, false);
          case 6:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 5]]);
    }));
    return function (_x1, _x10) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var FUTURES_MAX_POSITION = exports.FUTURES_MAX_POSITION = 'FUTURES_MAX_POSITION';
var getFuturesMaxPosition = exports.getFuturesMaxPosition = function getFuturesMaxPosition(leverage) {
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(dispatch, getState) {
      var state, instrumentId, response;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            state = getState();
            instrumentId = (0, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector)(state);
            _context8.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetFuturesMaxPositionAmount', {
              InstrumentId: instrumentId,
              LeverageMultiplier: leverage
            }));
          case 1:
            response = _context8.v;
            if (!(response.result !== false)) {
              _context8.n = 2;
              break;
            }
            dispatch({
              type: FUTURES_MAX_POSITION,
              payload: response
            });
            return _context8.a(2, response);
          case 2:
            console.log('GetFuturesMaxPositionAmount error: ', response.errormsg);
            return _context8.a(2, null);
        }
      }, _callee8);
    }));
    return function (_x11, _x12) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var RECEIVE_FUTURES_ESTIMATED_MAX_AMOUNT = exports.RECEIVE_FUTURES_ESTIMATED_MAX_AMOUNT = 'RECEIVE_FUTURES_ESTIMATED_MAX_AMOUNT';
var receiveFuturesEstimatedMaxAmount = exports.receiveFuturesEstimatedMaxAmount = function receiveFuturesEstimatedMaxAmount(estimatedMaxAmount) {
  return {
    type: RECEIVE_FUTURES_ESTIMATED_MAX_AMOUNT,
    payload: estimatedMaxAmount
  };
};
var getFuturesEstimatedMaxAmount = exports.getFuturesEstimatedMaxAmount = function getFuturesEstimatedMaxAmount(_ref1) {
  var MaxPositionAmount = _ref1.MaxPositionAmount,
    EntryPrice = _ref1.EntryPrice,
    LeverageMultiplier = _ref1.LeverageMultiplier;
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(dispatch, getState) {
      var instrumentId, response;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            instrumentId = (0, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector)(getState());
            _context9.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetFuturesEstimatedMaxAmount', {
              MaxPositionAmount: MaxPositionAmount,
              EntryPrice: EntryPrice,
              InstrumentId: instrumentId,
              LeverageMultiplier: LeverageMultiplier
            }));
          case 1:
            response = _context9.v;
            if (!(response.result !== false)) {
              _context9.n = 2;
              break;
            }
            dispatch(receiveFuturesEstimatedMaxAmount(response));
            return _context9.a(2, response);
          case 2:
            console.error('GetFuturesEstimatedMaxAmount error: ', response);
            return _context9.a(2, null);
          case 3:
            return _context9.a(2);
        }
      }, _callee9);
    }));
    return function (_x13, _x14) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var RECEIVE_FUTURES_ORDER_TOTAL = exports.RECEIVE_FUTURES_ORDER_TOTAL = 'RECEIVE_FUTURES_ORDER_TOTAL';
var receiveFuturesOrderTotal = exports.receiveFuturesOrderTotal = function receiveFuturesOrderTotal(payload) {
  return {
    type: RECEIVE_FUTURES_ORDER_TOTAL,
    payload: payload
  };
};
var GetFuturesOrderCost = exports.GetFuturesOrderCost = function GetFuturesOrderCost(InstrumentId, Quantity, EntryPrice, ReferencePrice, Leverage, IsByOrderQuantity) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(dispatch, getState) {
      var state, OMSId, AccountId, response, _t8;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            state = getState();
            OMSId = state.user.userInfo.OMSId;
            AccountId = (0, _futuresSelectors.selectedAccountIdSelector)(state);
            _context0.p = 1;
            _context0.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetFuturesOrderCost', {
              OMSId: OMSId,
              AccountId: AccountId,
              InstrumentId: InstrumentId,
              Quantity: Quantity,
              EntryPrice: EntryPrice,
              ReferencePrice: ReferencePrice,
              Leverage: Leverage,
              IsByOrderQuantity: IsByOrderQuantity
            }));
          case 2:
            response = _context0.v;
            if (!response || (response === null || response === void 0 ? void 0 : response.IsSuccess) === false) {
              console.error('GetFuturesOrderCost error: ', response);
            } else {
              dispatch(receiveFuturesOrderTotal(response.Value));
            }
            _context0.n = 4;
            break;
          case 3:
            _context0.p = 3;
            _t8 = _context0.v;
            console.error('GetFuturesOrderCost error: ', _t8);
          case 4:
            return _context0.a(2);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref11.apply(this, arguments);
    };
  }();
};